import React from 'react'
import { IContactFromData } from '../../exports/interfaces'
import { useCompanyDetailsContext } from '../../context/CompanyDetailsContext';
import useMobile from "../../hooks/useMobile";

const ContactTiles = (props: {contactFormData: IContactFromData[]}) => {
      const { companyDetailsData } = useCompanyDetailsContext();
      const mobile = useMobile();
    
  return (
    <section className="contact-info">
    <div className="container">
        <div className="row">
            <div className="col-xl-4 col-lg-4">
                <div className="contact-info__single" style={{height: mobile ? '260px' : '220px'}}>
                    <h4 className="contact-info__title">About</h4>
                    <p className="contact-info__text">{props?.contactFormData[0]?.attributes?.About_Description}</p>
                </div>
            </div>
            <div className="col-xl-4 col-lg-4">
                <div className="contact-info__single contact-info__single-2" style={{height: mobile ? '260px' : '220px'}}>
                    <h4 className="contact-info__title">Address</h4>
                    <p className="contact-info__text">{companyDetailsData[0]?.attributes?.Company_Address}</p>
                </div>
            </div>
            <div className="col-xl-4 col-lg-4">
                <div className="contact-info__single contact-info__single-3" style={{height: mobile ? '260px' : '220px'}}>
                    <h4 className="contact-info__title">Contact</h4>
                    <p className="contact-info__email-phone">
                        <a href={`mailto:${companyDetailsData[0]?.attributes?.Email}`}
                            className="contact-info__email">{companyDetailsData[0]?.attributes?.Email}</a>
                        <a href={`tel:${companyDetailsData[0]?.attributes?.Phone_Number}`} className="contact-info__phone">{companyDetailsData[0]?.attributes?.Phone_Number}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default ContactTiles